module.exports = __webpack_public_path__ + "img/installer-win-01.8a9117e0.png";